import * as z from 'zod'
import {PatientsTherapiesFiltersSchema} from '../patients-therapies/schemas'
import {SortSchema} from '@cypro/ui/schemas'

export const ProductionSearchSchema = z.object({
  filters: PatientsTherapiesFiltersSchema.default({
    productionStatus: 'validation_queue',
    therapyDate: [new Date().toISOString().split('T')[0]],
  }),
  sort: z.array(SortSchema).default([{id: 'time', desc: false}]),
})
